import { CompanyBuildingUnitView } from "@app/core";


export class EventRequestModel {
  id: number;
  requestId: number;
  requestorId: number;
  requestorName: string;
  requestStatusName: string;
  acknowledgementId: number;
  acknowledgementStatusName: string;
  remarks: string;
  postDate: Date;
  slaDate: Date;
  requestDate: Date;
  eventTypeName: string;
  secondaryPointName: string;
  primaryPointName: string;
  requestNumber: string;
  tenantName: string;
  eventTitle: string;
  startDate: Date;
  endDate: Date;
  eventTypeId: string;
  eventLocation: CompanyBuildingUnitView[];
  eventAdsLocation: CompanyBuildingUnitView[];

  primaryPointEmail: string;
  primaryPointPhone: string;
  secondaryPointEmail: string;
  secondaryPointPhone: string;
  eventStartTime: string;
  eventEndTime: string;
  isPhotography: boolean;
  attendeesNoOfPublic: number;
  attendeesPublicDetails: string;
  attendeesNoOfPrivate: number;
  attendeesPrivateDetails: string;
  attendeesNoOfVIPExecutive: number;
  attendeesVIPExecutiveDetails: string;
  attendeesNoOfVIPDiplomat: number;
  attendeesVIPDiplomatDetails: string;
  attendeesVIPNoOfMinister: number;
  attendeesVIPNoOfMinisterDetails: string;
  attendeesNoOfOtherAttendees: number;
  attendeesOtherDetails: string;
  attendeesNoOfVIPHeadOfState: number;
  attendeesVIPHeadOfStateDetails: string;

  isViaVisitorcards: boolean;
  isViaEventInvitation: boolean;
  isViaGatePresencePermit: boolean;

 
  isAttendeesWillArriveByBus: boolean;
  noOfBusses: number;
  busCapacity: number;
  busDimensions: string;
  busArrivaltime: string;
  busDeparturetime: string;


  noOfPublicParkingSpot: number;
  noOfVIPParkingSpot: number;
  publicParkingListView: string [];
  privateParkingListView: string[];
  publicParkingListViewIds: number[];
  privateParkingListViewIds: number[];
  eventLocations: string[];
  eventLocationsDisplay: string;

 
  permitHolderName: string;
  permitHolderPhone: string;
  permitHolderEmail: string;
  gppJustification: string;


  arrivaltime: string;
  departuretime: string;
 cateringCompanyName: string;
  cateringFocalPoint: string;
  cateringCellPhone: string;
  cateringEmail: string;
  cateringSetupDate: Date;

  cateringSetupTime: string;
  cateringClearingDate: Date;
  cateringClearingTime: string;
  cateringMovementQSTPFurniture: boolean;
  cateringStorageAreaRequest: boolean;

  isCatered: boolean;
  isAdvertising: boolean; 
  isHeavyEquipment: boolean;

  adsInstallationDate: Date;
  adsInstallationTime: string;
  adsRemovalDate: Date;
  adsRemovalTime: string;

  isFurnitureOutside: boolean;
  heavyEquipArrivalDate: Date;
  heavyEquipArrivalTime: string;
  heavyEquipRemovingDate: Date;
  heavyEquipRemovingTime: string;
  heavyAdditionalRequirements: string;
  heavyEquipmentsDelivery: string;

  otherRequirements: string;
  listOfFiles: string[];

  isValidFeedback: boolean;
  isValidSLARequest: boolean;
  userCanUpdateGPP: boolean;
  userCanCancelRequest: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request.ts